import { render, staticRenderFns } from "./PasswordResetInput.vue?vue&type=template&id=6d1a3151&"
import script from "./PasswordResetInput.vue?vue&type=script&lang=js&"
export * from "./PasswordResetInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports